import { render, staticRenderFns } from "./zhuanpan.vue?vue&type=template&id=0b9269dc&scoped=true&"
import script from "./zhuanpan.vue?vue&type=script&lang=js&"
export * from "./zhuanpan.vue?vue&type=script&lang=js&"
import style0 from "./zhuanpan.vue?vue&type=style&index=0&id=0b9269dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9269dc",
  null
  
)

export default component.exports